import React, { useContext } from "react";
import { ThemeContext } from "../../context/ThemeProvider";
import HTMLContent from "../HTMLContent";



function QuestionOptions(props) {
  const { theme, getThemeName } = useContext(ThemeContext);

  // Inline styles as an alternative to StyleSheet
  const styles = {
    container: {
      flex: "1.0",
      alignItems: "center",
      borderWidth: "1px",
      borderStyle: "solid",
      // Unselected option border. gray[200] equals the dark surface for slate brands — for
      // TrainingCamp dark, gray[200] (#0f172a) IS backgrounds.secondary, so the border was
      // invisible. Use the adaptive borders.hover token: a visible 20%-white line on dark,
      // a subtle gray on light.
      borderColor: theme.borders.hover,
      borderRadius: "8px",
      marginTop: "10px",
      flexDirection: "row",
    },
    textContainer: {
      flex: "1.0",
      padding: "15px",
    },
    options: {
      flex: "1.0",
      padding: "20px",
      justifyContent: "center",
      borderRadius: "8px",
      borderLeftWidth: "1px",
      borderLeftStyle: "solid",
      borderLeftColor: theme.borders.hover, // see container border note above
    },
  };

  const OPTIONS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  const item = props.item;
  const index = props.index;
  const isShowAnswer = props.isShowAnswer;
  const isSubmit = props.isSubmit;
  const correct = props.correct;
  const selected = props.selected;
  const didNotAnswer = props.didNotAnswer;

  function getStyles() {
    
    let containerStyle = { ...styles.container };
    let optionsStyle = { ...styles.options };
    let optionsTextStyle = theme?.primary?.gray?.[500];

    if (Array.isArray(props.correct)) {
      if (isSubmit) {
        if (correct.includes(OPTIONS[index])) {
          if (selected?.includes(OPTIONS[index])) {
            containerStyle.borderColor = theme.primary.green[500];
            optionsStyle.backgroundColor = theme.primary.green[500];
            optionsTextStyle = theme.neutral.white;
          } else {
            // Missed correct answer — pale green tint, green border, normal text color
            containerStyle.borderColor = theme.primary.green[500];
            optionsStyle.backgroundColor = theme.primary.green[100];
            optionsTextStyle = theme.primary.green[500];
          }
        } else if (selected?.includes(OPTIONS[index])) {
          containerStyle.borderColor = theme.primary.red[500];
          optionsStyle.backgroundColor = theme.primary.red[500];
          optionsTextStyle = theme.neutral.white;
        }
      } else if (selected?.includes(OPTIONS[index])) {
        containerStyle.borderColor = theme.primary.blue[500];
        optionsStyle.backgroundColor = theme.primary.blue[500];
        optionsTextStyle = theme.neutral.white;
      }
    } else {
      if (isShowAnswer && (selected && selected !== "X" || didNotAnswer)) {
        if (selected === correct && OPTIONS[index] === correct) {
          containerStyle.borderColor = theme.primary.green[500];
          optionsStyle.backgroundColor = theme.primary.green[500];
          optionsTextStyle = theme.neutral.white;
        } else if (correct === OPTIONS[index]) {
          containerStyle.borderColor = theme.primary.green[500];
          optionsStyle.backgroundColor = theme.primary.green[500];
          optionsTextStyle = theme.neutral.white;
        } else if (selected === OPTIONS[index]) {
          containerStyle.borderColor = theme.primary.red[500];
          optionsStyle.backgroundColor = theme.primary.red[500];
          optionsTextStyle = theme.neutral.white;
        }
      } else if (selected === OPTIONS[index]) {
        containerStyle.borderColor = theme.primary.blue[500];
        optionsStyle.backgroundColor = theme.primary.blue[500];
        optionsTextStyle = theme.neutral.white;
      }
    }

    return {
      container: containerStyle,
      options: optionsStyle,
      options_text: optionsTextStyle,
    };
  }

  function onPress() {
    if (Array.isArray(props.correct)) {
      if (!props.isSubmit) {
        props.onPress();
      }
    } else {
      if (props.isShowAnswer && (selected == "X" || selected == null)) {
        props.onPress();
      } else if (!props.isShowAnswer) {
        props.onPress();
      }
    }
  }

  const optionsStyle = getStyles();
  return (
    <div 
      style={optionsStyle.container}
      className="flex items-center justify-between cursor-pointer"
      onClick={() => onPress()}
    >
      <div style={styles.textContainer}>
        {/* Assuming QuestionText is a standard React component */}
        <HTMLContent index={index} htmlContent={item} />
        
      </div>
      <div className="h-full">
        <div
          className="h-full flex items-center justify-center"
          style={optionsStyle.options}
        >
          {/* Assuming Text is a standard React component */}
          <Text
            className="text-[18px] sm:text-[18px] md:text-[22px] lg:text-[25px]"
            // font={FONT_NAME.Manrope.Medium}
            // color={optionsStyle.options_text}
            color={optionsStyle.options_text}
            size="30px"
          >
            {OPTIONS[index]}
          </Text>
        </div>
      </div>
    </div>
  );
}

// QuestionText Component
const QuestionText = ({ color, key, text }) => (
  <p style={{ color }} key={key}>
    {text}
  </p>
);

// Text Component
const Text = ({ font, color, size, children, className }) => {
  // console.log(color, "text color");
  return (
    <span className={className} style={{ fontSize: "1.25rem", color: color }}>
      {children}
    </span>
  );
};

export default QuestionOptions;
